export const getTransactionFee = async (client, { baseUrl }, { txId }) => {
    const apiUrl = `${baseUrl}/tx/${txId}`;
    const response = (await client.request({
        url: apiUrl,
        fetchOptions: { method: 'GET' },
    }));
    if (response.error) {
        return { error: response.error };
    }
    return {
        result: BigInt(response.fees),
    };
};
//# sourceMappingURL=getTransactionFee.js.map